import React, { useEffect, useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle as MuiDialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Typography,
  withStyles,
  withTheme,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { compose } from 'recompose';
import { withUserProfile } from '../../../../../../userProfile/userProfileContext';
import styles from './styles';
import PastPickupGrid from './Grid';
import appConstants from '../../../../../../appConstants';
import { getDataWithQueryString } from '../../../../../../api/componentAPIs';
import { format } from 'date-fns';
import { getDefaultDateRange } from './utils';

const DialogTitle = withStyles(styles)(({ children, classes, onClose, ...other }) => (
  <>
    <MuiDialogTitle disableTypography classes={{ root: classes.dialogTitle }} {...other}>
      <Typography variant="h6" className={classes.title}>
        {children}
      </Typography>
      {onClose && (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      )}
    </MuiDialogTitle>
    <div className={classes.grayBar}></div>
  </>
));

const PastPickup = ({ classes, open, handleClose, theme = 'modernLight', userData, glEventHub }) => {
  const [pickups, setPickups] = useState([]);
  const [gridMessage, setGridMessage] = useState(appConstants.GRID_STATUS.LOADING);
  const [selectedDateRange, setSelectedDateRange] = useState(getDefaultDateRange(null, null));

  useEffect(() => {
    getPastPickups();
  }, [selectedDateRange]);

  const changeSelectedDateRange = (dateRange) => {
    setSelectedDateRange(dateRange);
  };

  const getPastPickups = () => {
    const { startDate, endDate } = selectedDateRange[0];
    return getDataWithQueryString(
      'GetAllPastPickups',
      `terminalCode=${userData.userProfile.terminal.code}&fromDate=${format(
        startDate,
        appConstants.APP_DATE_FORMAT
      )}&toDate=${format(endDate, appConstants.APP_DATE_FORMAT)}`
    ).then(
      (response) => {
        if (response?.status >= 200 && response?.status < 400) {
          setPickups(response.data);
          setGridMessage(appConstants.GRID_STATUS.SUCCESS);
          return;
        }
        handleAPIError();
      },
      (_error) => {
        handleAPIError();
      }
    );
  };

  const handleAPIError = () => {
    setPickups([]);
    setGridMessage(appConstants.GRID_STATUS.ERROR);
  };

  return (
    <Dialog
      maxWidth='lg'
      onClose={handleClose}
      aria-labelledby="dialog-title"
      open={open}
      classes={{ paper: classes.dialog }}
      className={`${classes.dialogWrapper} ${theme.themeName}`}>
      <DialogTitle id="dialog-title" onClose={handleClose}>
        Past Pickups
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContent }} className="customScroll">
        <div className={classes.gridContainer}>
          <PastPickupGrid
            pickups={pickups}
            gridMessage={gridMessage}
            changeSelectedDateRange={changeSelectedDateRange}
            selectedDateRange={selectedDateRange}
            glEventHub={glEventHub}
          />
        </div>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogFooter }}>
        <Button
          onClick={handleClose}
          color="primary"
          variant="outlined"
          className={classes.actionButton}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default compose(withUserProfile, withStyles(styles), withTheme())(PastPickup);
